<template>
    <div class="col backgroundForm">
          
          <div class="alert alert-info" align="center" role="alert">
              <h4 class="alert-heading">Depositos Registrados</h4>        
          </div>
  
          <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <a class="nav-item nav-link active" id="nav-gral" data-toggle="tab" href="#nav-reg-dia" role="tab" aria-controls="nav-gral" aria-selected="true"><font-awesome-icon icon="plus" /> Migracion de Datos</a>
  
                  <!-- <a class="nav-item nav-link" id="nav-update-gral" data-toggle="tab" href="#nav-seg-cert" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="edit" /> Identificar Despositos</a> -->
  
              </div>
          </nav>
  
          <div class="tab-content" id="nav-tabContent">
              <!-- Asignacion de presupuesto anual -->
              <div class="tab-pane fade show active" id="nav-reg-dia" role="tabpanel" aria-labelledby="nav-capitan-tab">
                  <br>
                  <div class="row">
                      <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                          Vaciado de Revistas y Juegos de Guerra
                      </div>
                  </div>
  
                  <div class="mb-3">
                    <label for="formFile" class="form-label">Archivo Excel DIA</label>
                      <input type="file" @change="mLeerDatos" name="archivoExcel" id="archivoExcel" class="form-control">
                  </div>
                  
  
                  <button class="btn btn-warning col-12 col-md-4 offset-md-4" @click="mSubirDatos"><font-awesome-icon icon="list" /> Subir Información Sistema</button>
                  <br><br>
  
                  <div v-if="listado_migrado.length>0">
                  <h5>Listado de Informacion a Migrar</h5>
                  <div class="table-responsive" v-if="listado_migrado.length>0">
                      <table class="table">
                          <thead>
                              <tr>
                                  <th>#</th>
                                  <th>Identificador</th>
                                  <th>Gestion</th>
                                  <th>Fecha Inicio</th>
                                  <th>Fecha Conclusión</th>
                                  <th>Unidad</th>
                                  <th>Personal</th>
                                  <th>Cedula de Identidad</th>
                                  <th>Cargo</th>
                                  <th>Juego/Revista</th>
                                  <th>Titulo</th>
                                  <th>Calificación</th>
                                  <th>Delegado</th>
                                  <th>Observador A</th>
                                  <th>Observador B</th>
                                  <th>Clave Unidad</th>
                                  <th>Carnet Delegado</th>
                                  <th>Carnet Observador A</th>
                                  <th>Carnet Observador B</th>
                                  <th>Calificador</th>
                              </tr>
                              <tr v-for="(lc, index) in listado_migrado" :key="lc.documento">
                                  <td>{{ index+1 }}</td>
                                  <td>{{ lc[0] }}</td>
                                  <td>{{ lc[1] }}</td>
                                  <td>{{ lc[2] }}</td>
                                  <td>{{ lc[3] }}</td>
                                  <td>{{ lc[4] }}</td>
                                  <td>{{ lc[5] }}</td>
                                  <td>{{ lc[6] }}</td>
                                  <td>{{ lc[7] }}</td>
                                  <td>{{ lc[8] }}</td>
                                  <td>{{ lc[9] }}</td>
                                  <td>{{ lc[10] }}</td>
                                  <td>{{ lc[11] }}</td>
                                  <td>{{ lc[12] }}</td>
                                  <td>{{ lc[13] }}</td>
                                  <td>{{ lc[14] }}</td>
                                  <td>{{ lc[15] }}</td>
                                  <td>{{ lc[16] }}</td>
                                  <td>{{ lc[17] }}</td>
                                  <td>{{ lc[18] }}</td>
                              </tr>
                          </thead>
                      </table>
                      </div>
                  </div>
  
                  <div v-if="listado_observados.length>0">
                  <h5 class="text-danger">Listado de Informacion Observada en el Vaciado de Datos</h5>
                  <hr>
                  <button class="col col-md-2 offset-md-8 btn btn-info" @click="mCopyToClipboard(table_observed)" v-if="table_results!=='' && table_results!==null "> <font-awesome-icon icon="copy" size="lg" /> Copiar</button>
                  <div class="table-responsive" :id="table_observed" v-if="listado_observados.length>0">
                      <table class="table">
                          <thead>
                              <tr>
                                  <th>#</th>
                                  <th>Fecha Deposito</th>
                                  <th>Seccion</th>
                                  <th>Nro. Comprobante</th>
                                  <th>Codigo Operación</th>
                                  <th>Nro. Documento</th>
                                  <th>Glosa</th>
                                  <th>Cuenta Trans</th>
                                  <th>Debitos</th>
                                  <th>Creditos</th>
                                  <th>Saldos</th>
                                  <th>Importe Conciliar</th>
                                  <th>Estado</th>
                              </tr>
                              <tr v-for="(lc, index) in listado_observados" :key="lc.documento">
                                  <td>{{ index+1 }}</td>
                                  <td>{{ lc.fecha }}</td>
                                  <td>{{ lc.seccion }}</td>
                                  <td>{{ lc.comprobante }}</td>
                                  <td>{{ lc.cod_operacion }}</td>
                                  <td>{{ lc.documento }}</td>
                                  <td>{{ lc.glosa }}</td>
                                  <td>{{ lc.cuenta_trans }}</td>
                                  <td>{{ lc.debito }}</td>
                                  <td>{{ lc.credito }}</td>
                                  <td>{{ lc.saldo }}</td>
                                  <td>{{ lc.importe_conciliar }}</td>
                                  <td>{{ lc.estado }}</td>
                              </tr>
                          </thead>
                      </table>
                      </div>
                  </div>
  
              </div>
              <!-- reformulacion del poa -->
              <!-- <div class="tab-pane fade" id="nav-seg-cert" role="tabpanel" aria-labelledby="nav-capitan-tab">
                  <br>                
                  <div class="row">
                      <div class="col-12 col-sm-6 offset-sm-3 alert alert-warning" align="center">
                          Identificacion de Despositos y Reporte
                      </div>
                  </div>
  
                  <button class="btn btn-outline-info col-12 col-md-2 offset-md-5" @click="mIdentificaDeposito" :disabled="is_disabled2"><font-awesome-icon icon="sync-alt" />Identificar Depositos</button>
                  <br><br>
  
                  <h5>Reporte de Depositos Registrados DAF</h5>
                  <hr>
                  <div class="row">
                      <div class="form-group col-12 col-md-4 offset-md-2">
                          <label for="t_file">Fecha Inicio</label>
                          <input type="date"  style="text-transform: uppercase;" name="cedula_sol" id="cedula_sol" class="form-control" autocomplete="off" v-model="daf_depositos.inicio">
                      </div>
                      <div class="form-group col-12 col-md-4">
                          <label for="t_file">Fecha Final</label>
                          <input type="date" name="date_sol" id="date_sol" class="form-control" autocomplete="off" style="text-transform: uppercase;" v-model="daf_depositos.final">
                      </div>
                      
                  </div>
  
                  <button class="btn btn-outline-dark col-12 col-md-4 offset-md-4" @click="mReportSolicitudesDaf"><font-awesome-icon icon="file-excel" />Reporte Excel</button>
  
              </div>     -->
          </div>
      </div>
  </template>
  
  <script>
  import Vue from 'vue';
  import axios from 'axios';
  const qs = require('qs');
  
  import readXlsFile from 'read-excel-file'
  
  import modalLoading from '../modal/modalLoading';
  export default {
      data(){
          return {
              solicitud_certificado:{
                  inicio:'',
                  final:''
              },
              resultado_busqueda_admin:{},
              codigo_busqueda_admin:'',
              listado_migrado:[],
              observacion:null,
              is_disabled:false,
              listado_observados:[],
              table_observed:'table_observed',
              is_disabled2:false,
              daf_depositos:{
                  inicio:'',
                  final:''
              }
          }
      },
      mounted(){
        //   this.mChargeInit();
      },
      methods:{
          mCopyToClipboard(elemento) {
              var $temp = $("<input>")
              $("body").append($temp);
              // console.log($(`#${elemento}`));
              $temp.val($(`#${elemento}`).html()).select();
              document.execCommand("copy");
              $temp.remove();
              toastr.info('Tabla copiada con exito', 'Archivo copiado')
          },
          mLeerDatos(){
              this.listado_migrado=[];
              this.listado_observados=[];
              let input=document.getElementById("archivoExcel");
              readXlsFile(input.files[0]).then((rows) => {
                  // rows.forEach(dts=>{
                  //     console.log(dts);
                  // })
                  this.listado_migrado=rows;
              })
          },
          mValidateInfo(){
              if(this.listado_migrado.length===0){
                  toastr.warning('Seleccione un archivo a subir para migrar la informacion');
                  return false;
              }
              return true;
          },
          async mIdentificaDeposito(){
              this.is_disabled2=true;
              toastr.warning('Porfavor debe esperar mientras el programa identifica los depositos, espere a que el boton se vuelva a habilitar', 'Advertencia');
              let depIdentificar=await axios.get(`identificaDepos?api_token=${Vue.auth.getToken()}`);
              console.log(depIdentificar);
  
              if(depIdentificar.data.status){
                  toastr.success(depIdentificar.data.respuesta);
                  setTimeout(()=>{
                      this.is_disabled2=false;
                  }, 2000)
              }else{
                  toastr.warning(depIdentificar.data.respuesta);
              }
          },
          mSubirDatos(){
              // console.log('llegando al envio de los datos')
              if(this.mValidateInfo()){
                  let message = {
                  title: 'Subir Información',
                  body: `La Informacion que subira al sistema sera validada y se procedera con la migracion ¿esta Usted de acuerdo con el proceso? es irreversible`
                  };
  
                  let npr=new Promise((resolve, reject)=>{
                      this.$dialog
                      .confirm(message)
                      .then(function(dialog) {
                          resolve(true);          
                      })
                      .catch(function() {
                          resolve(false);
                      });
                  });
  
              npr.then( async (msg) =>{
                  if(msg){
                      try {
                          console.log('se envia el registro al servidor')
                          // this.title_m="Registrando";
                          // this.activeModal(this.id_m_progress);
                          this.is_disabled=true;
                          this.listado_observados=[];
                          let dtsSubir={
                              migracion:JSON.stringify(this.listado_migrado)
                          }
                          let rsc=await axios.post(`uploadDia?api_token=${Vue.auth.getToken()}`, qs.stringify(dtsSubir));
                          // console.log(rsc);
                          if(rsc.data.status){
                              // mensaje de exito y limpiamos el formulario identificar el documento de igual manera
                              this.listado_migrado=[];
                              toastr.success(rsc.data.respuesta, 'Exito');
                            //   this.listado_observados=rsc.data.observados;
  
                          }else{                            
                              // solo mostramos el mensaje de error
                              toastr.error(`${rsc.data.respuesta}`, 'Error');
                          }
                          setTimeout(()=>{
                              this.is_disabled=false;
                          }, 5000)
  
                      } catch (error) {
                          toastr.error('Consulte al administrador', 'Error');
                          setTimeout(()=>{
                              // this.inactiveModal(this.id_m_progress);
                              this.is_disabled=false;
                          }, 5000)
                      }
                  }else{
                      console.log('se ha rechazado el registro de solicitud');
                  }
              })
              }
          },
          mChargeInit(){
              let nd=new Date();
              let anio=nd.getFullYear();
              let mes=nd.getMonth()+1;
              mes = mes<10 ? `0${mes}`:mes;
              let dia=nd.getDate();
              dia=dia<10 ? `0${dia}`:dia;
              this.daf_depositos.inicio=`${anio}-${mes}-${dia}`;
              this.daf_depositos.final=`${anio}-${mes}-${dia}`;
              // console.log(this.daf_depositos.fecha_deposito);
          },
          mValidateListDaf(){
              if(this.daf_depositos.inicio.length<9){
                  toastr.warning('Indique la fecha de Inicio de Busqueda', 'Advertencia');
                  return false;
  
              }
              if(this.daf_depositos.final.length<0){
                  toastr.warning('Indique la fecha de Final de Busqueda', 'Advertencia');
                  return false;
              }
              let aux_date_init=new Date(this.daf_depositos.inicio);
              let aux_date_end=new Date(this.daf_depositos.final);
              let milisegundos1=aux_date_init.getTime();
              let milisegundos2=aux_date_end.getTime();
              if(milisegundos1>milisegundos2){
                  toastr.warning('La fecha Inicial no puede ser mayor a la Final', 'Advertencia');
                  return false;
              }
              return true;
          },
          mReportSolicitudesDaf(){
              if(this.mValidateListDaf()){
                  this.url_report=btoa('excelDepositosDaf/'+this.daf_depositos.inicio+'/'+this.daf_depositos.final);
                  // let url_report=btoa(`${this.urlR}/${this.port_select.id }`);
                  // let url_report=btoa(`pdfOrdopI/${id}`)
                  let route = this.$router.resolve({path: `/report/${this.url_report}`});            
                  window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
              }
          },
          mShowModalSD(idM) {
             $("#" + idM).modal("show");
          },
          mCloseModalSD(idM) {
             $("#" + idM).modal("hide");
          }
      },
      components:{
          "modal-loading": modalLoading
      }
  }
  </script>
  
  <style>
  
  </style>


// WEBPACK FOOTER //
// src/components/ordop/OrdopDiaMigracion.vue